import { Injectable } from '@angular/core';
import { BodyOutputType, ToasterService, Toast } from 'angular2-toaster';
import { HttpErrorHandlerService } from './http-error-handler.service';

@Injectable()
export class AppToasterService extends ToasterService {

  constructor(private httpErrorHandler: HttpErrorHandlerService) {
    super();
  }

  pop(type?: string | Toast, title?: string, body?: any): Toast {
    if (type && typeof type === 'object') {
      return super.pop(type);
    }

    const resolved = this.httpErrorHandler.resolveToast(type as string, title, body);
    if (resolved.skip) {
      return null;
    }

    if (resolved.useTrustedHtml) {
      const toast: Toast = {
        type: resolved.type,
        title: resolved.title,
        body: resolved.body,
        bodyOutputType: BodyOutputType.TrustedHtml,
      };
      return super.pop(toast);
    }

    return super.pop(resolved.type, resolved.title, resolved.body);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1685922665/src/src/app/shared/services/app-toaster.service.ts